import Footer from '../../components/Footer';
import Header from '../../components/Header/Header';
import Leaderboard from '../../components/Leaderboard';
import { HomeWrapper } from '../GamePage/GamePage.styled';

export const LeaderboardPage: React.FC = () => {
    return (
      <HomeWrapper>
        <Header  />
        <Leaderboard fullView={true} />
        <Footer />
      </HomeWrapper>
    );
  };